
import {DateListModel, ClusterModel, CardModeModel, GroupModel, AreaModel, GroupTypeModel} from '../services/analytics/analytics.model';
import { StoreModel } from './store-common.model';

export class IndicatorsSearchToolbarModel {
    public date_structure: DateListModel;
    public cluster_list: ClusterModel[];
    public card_modes: CardModeModel[];
    public group_types: GroupTypeModel[];
    public groups: GroupModel[];
    public stores: StoreModel[];
    public areas: AreaModel[];
    public selectedStartDate: Date;
    public selectedEndDate: Date;
  }


// WEBPACK FOOTER //
// ./src/app/models/indicators-search-toolbar-model.model.ts